module.exports = __webpack_public_path__ + "static/bsas009.thumb-66f11f228a069f1825082df112026e01.jpg";